<template>
    <div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'Carousel2Wrapper',
}
</script>

<style>
    
</style>